import { Directive, Output, EventEmitter, HostBinding, HostListener } from '@angular/core';

@Directive({
	selector: '[copoAppDragDropFiles]',
})
export class DragDropFilesDirective {
	@Output() readonly fileDropped = new EventEmitter<FileList>();

	counter = 0;

	@HostBinding('style.background-color') get background() {
		return this.counter === 0 ? '#fff' : '#9ecbec';
	}

	@HostBinding('style.opacity') get opacity() {
		return this.counter === 0 ? '1' : '0.8';
	}

	@HostListener('dragenter', ['$event']) onDragEnter(evt: Event) {
		this.counter++;
		this.stopEvent(evt);
	}

	@HostListener('dragover', ['$event']) onDragOver(evt: Event) {
		this.stopEvent(evt);
	}

	@HostListener('dragleave', ['$event']) onDragLeave(evt: Event) {
		this.counter--;
		this.stopEvent(evt);
	}

	@HostListener('drop', ['$event']) onDrop(evt: DragEvent) {
		this.counter--;
		this.stopEvent(evt);
		if (evt.dataTransfer === null) {
			return;
		}
		const { files } = evt.dataTransfer;
		if (files.length > 0) {
			this.fileDropped.emit(files);
		}
	}

	private stopEvent(evt: Event) {
		evt.preventDefault();
		evt.stopPropagation();
	}
}
